
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTenantApiKeyPermissionsDto } from '../models/work-tenant-api-key-permissions-dto';

export function getUpdateTenantApiKeyDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    tenantId: new FormControl<number | undefined>(undefined),
    permissions: new FormControl<WorkTenantApiKeyPermissionsDto | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    expiresAt: new FormControl<string | undefined>(''),
})
;
}
      